import React from 'react';

export function validateYear(setYearErrorMsg: React.Dispatch<React.SetStateAction<string>>, year: string): void {
  if (year.length !== 4) {
    return;
  }
  const currentYear = new Date().getFullYear();
  const yearValue = Number(year);
  if (yearValue > currentYear) {
    setYearErrorMsg('Year cannot be in the future.');
  } else {
    setYearErrorMsg('');
  }
}

export function validateComplete(
  setComplete: React.Dispatch<React.SetStateAction<boolean>>,
  visaType: string,
  year: string,
  yearErrorMsg: string,
): void {
  const complete = visaType !== '' && year !== '' && year.length === 4 && yearErrorMsg === '';
  setComplete(complete);
}
